// src/components/SelecteurLangue.jsx
// ─────────────────────────────────────────────────────────────
// Bouton de langue : FR | EN. Le choix est mémorisé (voir i18n/Langue).
// `sombre` : variante pour un fond foncé (en-tête de l'accueil, bandeaux admin).
// ─────────────────────────────────────────────────────────────
import React from 'react';
import { LANGUES, useLangue } from '../i18n/Langue';
import './SelecteurLangue.css';

function SelecteurLangue({ sombre = false, className = '' }) {
  const { langue, setLangue } = useLangue();
  return (
    <div
      className={`langue${sombre ? ' langue--sombre' : ''}${className ? ` ${className}` : ''}`}
      role="group"
      aria-label="Langue / Language"
    >
      {LANGUES.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`langue-choix${langue === l.code ? ' is-active' : ''}`}
          aria-pressed={langue === l.code}
          lang={l.code}
          title={l.nom}
          onClick={() => setLangue(l.code)}
        >
          {l.court}
        </button>
      ))}
    </div>
  );
}

export default SelecteurLangue;
